import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "8f79a82a-4630-4d5b-be12-334d7e68ae8f",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-1.svg` },
  },
  {
    id: "e421b275-8562-4156-9763-1ceb851d0059",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-2.svg` },
  },
  {
    id: "666eb6ad-a838-4fb0-9093-8fab908474ae",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-3.svg` },
  },
  {
    id: "796e4429-9ea6-4aa5-ad6f-8165daac2ef2",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-4.svg` },
  },
  {
    id: "0a6f6f1f-415b-4e50-b71a-33e68e1dd4df",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-5.svg` },
  },
  {
    id: "1b654a83-1012-4f04-88ff-7745515b0c9c",
    options: { imageUrl: `${config.ASSETS_URL}/05/15/task/task-1-item-6.svg` },
  },
];

const groups = [
  { id: "ffe40250-359c-40ce-9839-4ee63c57b599", content: "Absorber", options: {} },
  { id: "c1b08cc3-32e4-4375-99d2-a1624db8cfd7", content: "Specular reflector", options: {} },
  { id: "b9c49ea9-4a5b-4a5d-a616-a04a5050945e", content: "Diffuser", options: {} },
  { id: "1a65722a-88e4-4db6-9e93-db0c92681c12", content: "Sound transparent", options: {} },
];

export const task: Task = {
  id: "c2ab7a92-8f04-4e30-bcf5-7bca1d6bbcac",
  solutionType: "group",
  type: "categorizeImages",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "ffe40250-359c-40ce-9839-4ee63c57b599",
      itemsId: ["8f79a82a-4630-4d5b-be12-334d7e68ae8f", "e421b275-8562-4156-9763-1ceb851d0059"],
    },
    { groupId: "c1b08cc3-32e4-4375-99d2-a1624db8cfd7", itemsId: ["666eb6ad-a838-4fb0-9093-8fab908474ae"] },
    {
      groupId: "b9c49ea9-4a5b-4a5d-a616-a04a5050945e",
      itemsId: ["796e4429-9ea6-4aa5-ad6f-8165daac2ef2", "0a6f6f1f-415b-4e50-b71a-33e68e1dd4df"],
    },
    { groupId: "1a65722a-88e4-4db6-9e93-db0c92681c12", itemsId: ["1b654a83-1012-4f04-88ff-7745515b0c9c"] },
  ],
};
